import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './WithdrawForm.module.scss'
import { getFormatedPrice } from 'src/core/helpers'
import { Row, Typography, Button, Form } from 'antd'
import { useAppSelector, useWindowSize } from 'src/app/hooks'
import { getCurrencyToken } from 'src/core/helpers/summary.helpers'
import WithDrawPayPalForm from './WithDrawPayPalForm/WithDrawPayPalForm'
import { CustomInputTotalAmount, CustomModal, CustomCol } from 'src/components'
import WithdrawBankTransferForm from './WithdrawBankTransferForm/WithdrawBankTransferForm'
import { currencyListSelector, selectCurrencyToken, summaryBalanceSelector } from 'src/features'

const WithdrawForm: React.FC<{ handleCancel: () => void }> = ({ handleCancel: handleCancelWithdrawModal }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const currency_code = useAppSelector(selectCurrencyToken)
  const currencyList = useAppSelector(currencyListSelector)
  const [totalAmount, setTotalAmount] = useState(0)
  const [paymentMethod, setPaymentMethod] = useState('')
  const [isModalPayPalVisible, setModalPayPalVisible] = useState(false)
  const [isModalBankTransferVisible, setModalBankTransferVisible] = useState(false)
  const { list: balanceList } = useAppSelector(summaryBalanceSelector)
  const { isMobile } = useWindowSize()

  const currencyBalance = balanceList.find(item => item.code === currency_code)

  const onSubmit = () => {
    if (paymentMethod === 'payPal') { setModalPayPalVisible(true) }
    else { setModalBankTransferVisible(true) }
    setPaymentMethod('')
  }

  const handlerClickAllBalance = () => {
    setTotalAmount(currencyBalance.balance)
    form.setFieldsValue({ ['totalAmount']: currencyBalance.balance })
  }

  return <>
    <Form
      name='withdraw'
      autoComplete='off'
      onFinish={onSubmit}
      form={form}
    >
      {/* Balance Label */}
      <div className='total-order has-text-right'
        style={{ fontWeight: 600, display: 'flex', justifyContent: 'space-between' }}>
        <span><Typography.Text>{t('Summary.Amount')}</Typography.Text> </span>
        <span>
          {`${t('Summary.Balance')}:  `}
          {getFormatedPrice(currencyBalance.balance, currencyBalance.code)}
          <a onClick={handlerClickAllBalance}> All</a>
        </span>
      </div>

      {/* Amount Form Item */}
      <CustomInputTotalAmount
        required
        name='totalAmount'
        onChange={setTotalAmount}
        max={currencyBalance.balance}
        placeholder={t('Summary.Amount')}
      />

      {/* Total Content */}
      <div className={styles.totalContent}>
        <span>{t('Summary.Total')} </span>
        <span>{getFormatedPrice(totalAmount, currency_code)}</span>
      </div>


      <Row justify='space-evenly'>
        <CustomCol lg={11}>
          <Button
            block
            size='large'
            type='primary'
            htmlType='submit'
            className='radius-100'
          >{t('Summary.BankTransfer')}
          </Button>
        </CustomCol>
        <CustomCol lg={11}>
          <Button
            block
            size='large'
            type='primary'
            htmlType='submit'
            className={isMobile ? 'radius-100 mt-3' : 'radius-100'}
            onClick={() => setPaymentMethod('payPal')}
          >{t('Summary.WithdrawWithPaypal')}
          </Button>
        </CustomCol>
      </Row>
    </Form>

    {/* Paypal Modal */}
    <CustomModal
      width={500}
      footer={null}
      destroyOnClose
      visible={isModalPayPalVisible}
      title={t('Summary.WithdrawWithPaypal')}
      onCancel={() => setModalPayPalVisible(false)}
    >
      <WithDrawPayPalForm
        amount={totalAmount}
        handleCancel={handleCancelWithdrawModal}
        selectCurrencyId={getCurrencyToken(currencyList, currency_code)}
      />
    </CustomModal>

    {/* Bank Transfer Modal */}
    <CustomModal
      width={600}
      footer={null}
      destroyOnClose
      visible={isModalBankTransferVisible}
      title={t('Summary.WithdrawWithBankTransfer')}
      className={styles.modalContent}
      onCancel={() => setModalBankTransferVisible(false)}
      bodyStyle={{ overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}
    >
      <WithdrawBankTransferForm
        amount={totalAmount}
        handleCancel={handleCancelWithdrawModal}
        selectCurrencyId={getCurrencyToken(currencyList, currency_code)}
      />
    </CustomModal>
  </>
}

export default WithdrawForm
